import React, {
  useCallback,
  useEffect,
  useMemo,
  useState
} from 'react';

import {
  Megaphone,
  Plus,
  Pause,
  Play,
  Square,
  RefreshCw,
  Clock,
  BadgeDollarSign,
  Users,
  CheckCircle2,
  Upload,
  Volume2,
  Trash2
} from 'lucide-react';

import {
  useSettings
} from '../contexts/SettingsContext';


const API = (
  process.env.REACT_APP_API_URL ||
  '/api'
).replace(/\/$/, '');


function dinheiro(valor) {
  const numero =
    Number(valor || 0);

  return numero.toLocaleString(
    'pt-BR',
    {
      style: 'currency',
      currency: 'BRL'
    }
  );
}


function dataLocal(valor) {
  if (!valor) {
    return '-';
  }

  const data =
    new Date(valor);

  if (
    Number.isNaN(
      data.getTime()
    )
  ) {
    return '-';
  }

  return data.toLocaleString(
    'pt-BR'
  );
}


function paraInputDateTime(data) {
  const d =
    new Date(data);

  const pad =
    numero =>
      String(numero)
        .padStart(2, '0');

  return (
    d.getFullYear() +
    '-' +
    pad(d.getMonth() + 1) +
    '-' +
    pad(d.getDate()) +
    'T' +
    pad(d.getHours()) +
    ':' +
    pad(d.getMinutes())
  );
}


function statusClasse(status) {
  switch (status) {
    case 'ATIVA':
      return 'bg-green-100 text-green-800 border-green-200';

    case 'PAUSADA':
      return 'bg-yellow-100 text-yellow-800 border-yellow-200';

    case 'FINALIZADA':
      return 'bg-gray-200 text-gray-700 border-gray-300';

    default:
      return 'bg-blue-100 text-blue-800 border-blue-200';
  }
}


export default function Promotions() {
  const {
    darkMode
  } = useSettings();

  const agora =
    new Date();

  /*
   * PROMOTION_END_DEFAULT_2359_V1
   *
   * A promoção termina, por padrão,
   * às 23:59 do dia final.
   * O usuário ainda pode alterar manualmente
   * o horário quando desejar.
   */
  const fimPadrao =
    new Date(
      agora.getTime() +
      24 * 60 * 60 * 1000
    );

  fimPadrao.setHours(
    23,
    59,
    0,
    0
  );

  const [promocoes, setPromocoes] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  const [salvando, setSalvando] =
    useState(false);

  const [erro, setErro] =
    useState('');

  const [sucesso, setSucesso] =
    useState('');

  /*
   * CRM_PROMOTION_AUDIO_FRONT_V1
   */
  const [
    audioProcessandoId,
    setAudioProcessandoId
  ] = useState(null);

  const [
    audioVersao,
    setAudioVersao
  ] = useState(Date.now());

  const [form, setForm] =
    useState({
      nome: '',
      desconto_valor: '300',
      mensagem:
        'Temos uma condição especial por tempo limitado para o serviço de Rating. Responda *EU QUERO* para aproveitar a condição promocional no PIX à vista.',
      palavra_chave:
        'EU QUERO',
      inicio_em:
        paraInputDateTime(
          agora
        ),
      fim_em:
        paraInputDateTime(
          fimPadrao
        ),
      intervalo_minutos:
        '3'
    });


  const carregar =
    useCallback(
      async () => {
        setLoading(true);
        setErro('');

        try {
          const response =
            await fetch(
              `${API}/promotions`,
              {
                credentials:
                  'include'
              }
            );

          const result =
            await response.json();

          if (!response.ok) {
            throw new Error(
              result.error ||
              'Não foi possível carregar as promoções.'
            );
          }

          setPromocoes(
            Array.isArray(
              result.data
            )
              ? result.data
              : []
          );

        } catch (error) {
          setErro(
            error.message
          );

        } finally {
          setLoading(false);
        }
      },
      []
    );


  useEffect(
    () => {
      carregar();
    },
    [
      carregar
    ]
  );


  const ativa =
    useMemo(
      () =>
        promocoes.find(
          item =>
            item.status ===
            'ATIVA'
        ) ||
        null,
      [
        promocoes
      ]
    );


  async function criarPromocao(
    event
  ) {
    event.preventDefault();

    setErro('');
    setSucesso('');
    setSalvando(true);

    try {
      const payload = {
        nome:
          form.nome.trim(),

        desconto_valor:
          Number(
            form.desconto_valor
          ),

        mensagem:
          form.mensagem.trim(),

        palavra_chave:
          form.palavra_chave
            .trim()
            .toUpperCase(),

        inicio_em:
          new Date(
            form.inicio_em
          ).toISOString(),

        fim_em:
          new Date(
            form.fim_em
          ).toISOString(),

        intervalo_minutos:
          Number(
            form.intervalo_minutos
          )
      };

      const response =
        await fetch(
          `${API}/promotions`,
          {
            method:
              'POST',

            credentials:
              'include',

            headers: {
              'Content-Type':
                'application/json'
            },

            body:
              JSON.stringify(
                payload
              )
          }
        );

      const result =
        await response.json();

      if (!response.ok) {
        throw new Error(
          result.error ||
          'Não foi possível criar a promoção.'
        );
      }

      setSucesso(
        'Promoção criada como RASCUNHO.'
      );

      setForm(
        atual => ({
          ...atual,
          nome: ''
        })
      );

      await carregar();

    } catch (error) {
      setErro(
        error.message
      );

    } finally {
      setSalvando(false);
    }
  }


  async function executarAcao(
    id,
    acao
  ) {
    setErro('');
    setSucesso('');

    try {
      const response =
        await fetch(
          `${API}/promotions/${id}/${acao}`,
          {
            method:
              'POST',

            credentials:
              'include'
          }
        );

      const result =
        await response.json();

      if (!response.ok) {
        throw new Error(
          result.error ||
          'Não foi possível executar a ação.'
        );
      }

      const nomeAcao = {
        ativar:
          'Promoção ativada.',
        pausar:
          'Promoção pausada.',
        finalizar:
          'Promoção finalizada.'
      };

      setSucesso(
        nomeAcao[acao] ||
        'Ação concluída.'
      );

      await carregar();

    } catch (error) {
      setErro(
        error.message
      );
    }
  }



  /*
   * CRM_PROMOTION_DELETE_FRONT_V1
   */
  async function excluirPromocao(
    promocao
  ) {
    if (
      !promocao ||
      promocao.status === 'ATIVA'
    ) {
      setErro(
        'Finalize ou pause a promoção antes de excluir.'
      );
      return;
    }

    const confirmar =
      window.confirm(
        'Excluir definitivamente a promoção "' +
        promocao.nome +
        '"?\n\n' +
        'A campanha e o histórico de destinatários/envios serão removidos permanentemente.\n\n' +
        'Esta ação não pode ser desfeita.'
      );

    if (!confirmar) {
      return;
    }

    setErro('');
    setSucesso('');

    try {
      const response =
        await fetch(
          `${API}/promotions/${promocao.id}`,
          {
            method:
              'DELETE',

            credentials:
              'include'
          }
        );

      const result =
        await response.json();

      if (!response.ok) {
        throw new Error(
          result.error ||
          'Não foi possível excluir a promoção.'
        );
      }

      setSucesso(
        'Promoção excluída com sucesso.'
      );

      await carregar();

    } catch (error) {
      setErro(
        error.message ||
        'Não foi possível excluir a promoção.'
      );
    }
  }


  /*
   * ==================================================
   * ÁUDIO DA PROMOÇÃO
   * ==================================================
   */

  async function enviarAudio(
    promocaoId,
    arquivo
  ) {
    if (!arquivo) {
      return;
    }

    setErro('');
    setSucesso('');
    setAudioProcessandoId(
      promocaoId
    );

    try {
      if (
        arquivo.size >
        15 * 1024 * 1024
      ) {
        throw new Error(
          'O áudio deve ter no máximo 15 MB.'
        );
      }

      const formData =
        new FormData();

      formData.append(
        'audio',
        arquivo
      );

      const response =
        await fetch(
          `${API}/promotions/${promocaoId}/audio`,
          {
            method:
              'POST',

            credentials:
              'include',

            body:
              formData
          }
        );

      const result =
        await response.json();

      if (!response.ok) {
        throw new Error(
          result.error ||
          'Não foi possível enviar o áudio.'
        );
      }

      setSucesso(
        'Áudio da promoção salvo com sucesso.'
      );

      setAudioVersao(
        Date.now()
      );

      await carregar();

    } catch (error) {
      setErro(
        error.message ||
        'Não foi possível enviar o áudio.'
      );

    } finally {
      setAudioProcessandoId(
        null
      );
    }
  }


  async function removerAudio(
    promocaoId
  ) {
    if (
      !window.confirm(
        'Remover o áudio desta promoção?'
      )
    ) {
      return;
    }

    setErro('');
    setSucesso('');
    setAudioProcessandoId(
      promocaoId
    );

    try {
      const response =
        await fetch(
          `${API}/promotions/${promocaoId}/audio`,
          {
            method:
              'DELETE',

            credentials:
              'include'
          }
        );

      const result =
        await response.json();

      if (!response.ok) {
        throw new Error(
          result.error ||
          'Não foi possível remover o áudio.'
        );
      }

      setSucesso(
        'Áudio removido.'
      );

      setAudioVersao(
        Date.now()
      );

      await carregar();

    } catch (error) {
      setErro(
        error.message ||
        'Não foi possível remover o áudio.'
      );

    } finally {
      setAudioProcessandoId(
        null
      );
    }
  }


  const cardClasse =
    darkMode
      ? 'bg-gray-800 border-gray-700 text-white'
      : 'bg-white border-gray-200 text-gray-900';

  const inputClasse =
    darkMode
      ? 'bg-gray-900 border-gray-700 text-white placeholder-gray-500'
      : 'bg-white border-gray-300 text-gray-900 placeholder-gray-400';


  return (
    <div className="space-y-6">

      <div className="flex items-start justify-between gap-4">

        <div>
          <div className="flex items-center gap-3">
            <Megaphone
              size={30}
              className="text-blue-500"
            />

            <h1 className="text-2xl font-bold">
              Promoções
            </h1>
          </div>

          <p className={
            darkMode
              ? 'text-gray-400 mt-2'
              : 'text-gray-600 mt-2'
          }>
            Campanhas promocionais para clientes que ainda não fecharam o serviço.
          </p>
        </div>

        <button
          type="button"
          onClick={carregar}
          className={
            'flex items-center gap-2 px-4 py-2 rounded-lg border ' +
            (
              darkMode
                ? 'border-gray-700 hover:bg-gray-800'
                : 'border-gray-300 hover:bg-gray-50'
            )
          }
        >
          <RefreshCw
            size={17}
          />
          Atualizar
        </button>
      </div>


      {erro && (
        <div className="p-4 rounded-lg bg-red-100 border border-red-200 text-red-800">
          {erro}
        </div>
      )}


      {sucesso && (
        <div className="p-4 rounded-lg bg-green-100 border border-green-200 text-green-800">
          {sucesso}
        </div>
      )}


      {ativa && (
        <div className="p-4 rounded-xl border border-green-300 bg-green-50 text-green-900">

          <div className="flex items-center gap-2 font-semibold">
            <CheckCircle2
              size={20}
            />

            Promoção ativa:
            {' '}
            {ativa.nome}
          </div>

          <div className="mt-2 text-sm">
            Desconto:
            {' '}
            <strong>
              {dinheiro(
                ativa.desconto_valor
              )}
            </strong>

            {' • '}

            Até:
            {' '}

            <strong>
              {dataLocal(
                ativa.fim_em
              )}
            </strong>
          </div>
        </div>
      )}


      <div className={
        `rounded-xl border p-6 ${cardClasse}`
      }>

        <div className="flex items-center gap-2 mb-5">
          <Plus
            size={20}
          />

          <h2 className="font-semibold text-lg">
            Nova promoção
          </h2>
        </div>


        <form
          onSubmit={criarPromocao}
          className="space-y-5"
        >

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">

            <div>
              <label className="block text-sm font-medium mb-1">
                Nome da promoção
              </label>

              <input
                type="text"
                required
                value={form.nome}
                onChange={
                  event =>
                    setForm({
                      ...form,
                      nome:
                        event.target.value
                    })
                }
                placeholder="Ex.: Promoção Agosto"
                className={
                  `w-full border rounded-lg px-3 py-2 ${inputClasse}`
                }
              />
            </div>


            <div>
              <label className="block text-sm font-medium mb-1">
                Desconto no PIX
              </label>

              <div className="relative">
                <BadgeDollarSign
                  size={18}
                  className="absolute left-3 top-3 text-gray-400"
                />

                <input
                  type="number"
                  min="1"
                  step="0.01"
                  required
                  value={
                    form.desconto_valor
                  }
                  onChange={
                    event =>
                      setForm({
                        ...form,
                        desconto_valor:
                          event.target.value
                      })
                  }
                  className={
                    `w-full border rounded-lg pl-10 pr-3 py-2 ${inputClasse}`
                  }
                />
              </div>

              <p className="text-xs text-gray-500 mt-1">
                O Vitor calculará: valor normal do PIX − desconto.
              </p>
            </div>
          </div>


          <div>
            <label className="block text-sm font-medium mb-1">
              Mensagem promocional
            </label>

            <textarea
              required
              rows={5}
              value={
                form.mensagem
              }
              onChange={
                event =>
                  setForm({
                    ...form,
                    mensagem:
                      event.target.value
                  })
              }
              className={
                `w-full border rounded-lg px-3 py-2 ${inputClasse}`
              }
            />
          </div>


          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">

            <div>
              <label className="block text-sm font-medium mb-1">
                Palavra-chave
              </label>

              <input
                type="text"
                value={
                  form.palavra_chave
                }
                onChange={
                  event =>
                    setForm({
                      ...form,
                      palavra_chave:
                        event.target.value
                    })
                }
                className={
                  `w-full border rounded-lg px-3 py-2 ${inputClasse}`
                }
              />

              <p className="text-xs text-gray-500 mt-1">
                Padrão: EU QUERO
              </p>
            </div>


            <div>
              <label className="block text-sm font-medium mb-1">
                Intervalo entre envios
              </label>

              <div className="relative">
                <Clock
                  size={18}
                  className="absolute left-3 top-3 text-gray-400"
                />

                <input
                  type="number"
                  min="1"
                  required
                  value={
                    form.intervalo_minutos
                  }
                  onChange={
                    event =>
                      setForm({
                        ...form,
                        intervalo_minutos:
                          event.target.value
                      })
                  }
                  className={
                    `w-full border rounded-lg pl-10 pr-3 py-2 ${inputClasse}`
                  }
                />
              </div>

              <p className="text-xs text-gray-500 mt-1">
                Em minutos. O envio será feito um cliente por vez.
              </p>
            </div>
          </div>


          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">

            <div>
              <label className="block text-sm font-medium mb-1">
                Início
              </label>

              <input
                type="datetime-local"
                required
                value={
                  form.inicio_em
                }
                onChange={
                  event =>
                    setForm({
                      ...form,
                      inicio_em:
                        event.target.value
                    })
                }
                className={
                  `w-full border rounded-lg px-3 py-2 ${inputClasse}`
                }
              />
            </div>


            <div>
              <label className="block text-sm font-medium mb-1">
                Final da promoção
              </label>

              <input
                type="datetime-local"
                required
                value={
                  form.fim_em
                }
                onChange={
                  event =>
                    setForm({
                      ...form,
                      fim_em:
                        event.target.value
                    })
                }
                className={
                  `w-full border rounded-lg px-3 py-2 ${inputClasse}`
                }
              />

              <p className="text-xs text-gray-500 mt-1">
                Padrão: 23:59 do último dia. Você pode alterar o horário se quiser encerrar antes.
              </p>
            </div>
          </div>


          <div className={
            'rounded-lg p-4 text-sm ' +
            (
              darkMode
                ? 'bg-gray-900 text-gray-300'
                : 'bg-blue-50 text-blue-900'
            )
          }>
            <strong>
              Regra da promoção:
            </strong>
            {' '}
            somente PIX à vista. Cartão e PIX Facilitado não serão oferecidos no fluxo promocional.
          </div>


          <button
            type="submit"
            disabled={salvando}
            className="flex items-center gap-2 bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white px-5 py-2.5 rounded-lg font-medium"
          >
            <Plus
              size={18}
            />

            {salvando
              ? 'Salvando...'
              : 'Criar promoção'}
          </button>
        </form>
      </div>


      <div className={
        `rounded-xl border ${cardClasse}`
      }>

        <div className="p-5 border-b border-gray-200">
          <div className="flex items-center gap-2">
            <Megaphone
              size={20}
            />

            <h2 className="font-semibold text-lg">
              Campanhas
            </h2>
          </div>
        </div>


        {loading ? (
          <div className="p-8 text-center text-gray-500">
            Carregando...
          </div>

        ) : promocoes.length === 0 ? (
          <div className="p-8 text-center text-gray-500">
            Nenhuma promoção criada.
          </div>

        ) : (
          <div className="divide-y divide-gray-200">

            {promocoes.map(
              promocao => (

                <div
                  key={promocao.id}
                  className="p-5"
                >

                  <div className="flex flex-col xl:flex-row xl:items-start justify-between gap-5">

                    <div className="min-w-0">

                      <div className="flex flex-wrap items-center gap-3">

                        <h3 className="font-semibold text-lg">
                          {promocao.nome}
                        </h3>

                        <span className={
                          `text-xs font-semibold px-2.5 py-1 rounded-full border ${statusClasse(promocao.status)}`
                        }>
                          {promocao.status}
                        </span>
                      </div>


                      <div className="mt-3 grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-3 text-sm">

                        <div>
                          <span className="text-gray-500">
                            Desconto
                          </span>

                          <div className="font-semibold">
                            {dinheiro(
                              promocao.desconto_valor
                            )}
                          </div>
                        </div>


                        <div>
                          <span className="text-gray-500">
                            Período
                          </span>

                          <div>
                            {dataLocal(
                              promocao.inicio_em
                            )}
                          </div>

                          <div>
                            até
                            {' '}
                            {dataLocal(
                              promocao.fim_em
                            )}
                          </div>
                        </div>


                        <div>
                          <span className="text-gray-500">
                            Intervalo
                          </span>

                          <div>
                            {promocao.intervalo_minutos}
                            {' '}
                            min
                          </div>
                        </div>


                        <div>
                          <span className="text-gray-500">
                            Palavra-chave
                          </span>

                          <div className="font-semibold">
                            {promocao.palavra_chave}
                          </div>
                        </div>
                      </div>


                      <div className="mt-4 flex flex-wrap gap-4 text-sm">

                        <span className="flex items-center gap-1">
                          <Users
                            size={16}
                          />
                          Destinatários:
                          {' '}
                          {Number(
                            promocao.total_destinatarios ||
                            0
                          )}
                        </span>

                        <span>
                          Enviados:
                          {' '}
                          {Number(
                            promocao.total_enviados ||
                            0
                          )}
                        </span>

                        <span>
                          Aceitaram:
                          {' '}
                          {Number(
                            promocao.total_aceitou ||
                            0
                          )}
                        </span>

                        <span>
                          Converteram:
                          {' '}
                          {Number(
                            promocao.total_converteu ||
                            0
                          )}
                        </span>
                      </div>


                      <div className="mt-4 text-sm whitespace-pre-wrap text-gray-500 max-w-4xl">
                        {promocao.mensagem}
                      </div>


                      {/* CRM_PROMOTION_AUDIO_FRONT_V1_UI */}
                      <div className={
                        'mt-5 rounded-lg border p-4 ' +
                        (
                          darkMode
                            ? 'border-gray-700 bg-gray-900'
                            : 'border-gray-200 bg-gray-50'
                        )
                      }>

                        <div className="flex items-center gap-2 font-medium mb-3">
                          <Volume2
                            size={18}
                          />

                          Áudio da promoção
                        </div>


                        {promocao.audio_path ? (
                          <div className="space-y-3">

                            <audio
                              key={
                                promocao.id +
                                '-' +
                                audioVersao
                              }
                              controls
                              preload="metadata"
                              className="w-full max-w-xl"
                              src={
                                `${API}/promotions/${promocao.id}/audio?v=${audioVersao}`
                              }
                            />

                            {promocao.status !==
                              'FINALIZADA' && (

                              <div className="flex flex-wrap gap-2">

                                <label className="cursor-pointer flex items-center gap-2 px-3 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white text-sm">

                                  <Upload
                                    size={16}
                                  />

                                  Trocar áudio

                                  <input
                                    type="file"
                                    accept="audio/*,.mp3,.ogg,.opus,.m4a,.aac,.wav"
                                    className="hidden"
                                    disabled={
                                      audioProcessandoId ===
                                      promocao.id
                                    }
                                    onChange={
                                      event => {
                                        const arquivo =
                                          event
                                            .target
                                            .files?.[0];

                                        enviarAudio(
                                          promocao.id,
                                          arquivo
                                        );

                                        event.target.value =
                                          '';
                                      }
                                    }
                                  />
                                </label>


                                <button
                                  type="button"
                                  disabled={
                                    audioProcessandoId ===
                                    promocao.id
                                  }
                                  onClick={
                                    () =>
                                      removerAudio(
                                        promocao.id
                                      )
                                  }
                                  className="flex items-center gap-2 px-3 py-2 rounded-lg bg-red-600 hover:bg-red-700 disabled:opacity-50 text-white text-sm"
                                >
                                  <Trash2
                                    size={16}
                                  />

                                  Remover
                                </button>
                              </div>
                            )}
                          </div>

                        ) : promocao.status !==
                          'FINALIZADA' ? (

                          <div>
                            <label className="cursor-pointer inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium">

                              <Upload
                                size={17}
                              />

                              {audioProcessandoId ===
                              promocao.id
                                ? 'Enviando...'
                                : 'Carregar áudio'}

                              <input
                                type="file"
                                accept="audio/*,.mp3,.ogg,.opus,.m4a,.aac,.wav"
                                className="hidden"
                                disabled={
                                  audioProcessandoId ===
                                  promocao.id
                                }
                                onChange={
                                  event => {
                                    const arquivo =
                                      event
                                        .target
                                        .files?.[0];

                                    enviarAudio(
                                      promocao.id,
                                      arquivo
                                    );

                                    event.target.value =
                                      '';
                                  }
                                }
                              />
                            </label>

                            <p className="mt-2 text-xs text-gray-500">
                              Opcional. MP3, OGG/Opus, M4A, AAC ou WAV. Máximo 15 MB.
                            </p>
                          </div>

                        ) : (
                          <span className="text-sm text-gray-500">
                            Nenhum áudio cadastrado.
                          </span>
                        )}

                        
                      </div>
                    </div>


                    <div className="flex flex-wrap gap-2">

                      {promocao.status !==
                        'ATIVA' &&
                        promocao.status !==
                        'FINALIZADA' && (

                        <button
                          type="button"
                          onClick={
                            () =>
                              executarAcao(
                                promocao.id,
                                'ativar'
                              )
                          }
                          className="flex items-center gap-2 bg-green-600 hover:bg-green-700 text-white px-3 py-2 rounded-lg text-sm"
                        >
                          <Play
                            size={16}
                          />
                          Ativar
                        </button>
                      )}


                      {promocao.status ===
                        'ATIVA' && (

                        <button
                          type="button"
                          onClick={
                            () =>
                              executarAcao(
                                promocao.id,
                                'pausar'
                              )
                          }
                          className="flex items-center gap-2 bg-yellow-500 hover:bg-yellow-600 text-white px-3 py-2 rounded-lg text-sm"
                        >
                          <Pause
                            size={16}
                          />
                          Pausar
                        </button>
                      )}


                      {promocao.status !==
                        'FINALIZADA' && (

                        <button
                          type="button"
                          onClick={
                            () => {
                              if (
                                window.confirm(
                                  'Finalizar esta promoção? Depois ela não poderá ser reativada.'
                                )
                              ) {
                                executarAcao(
                                  promocao.id,
                                  'finalizar'
                                );
                              }
                            }
                          }
                          className="flex items-center gap-2 bg-gray-600 hover:bg-gray-700 text-white px-3 py-2 rounded-lg text-sm"
                        >
                          <Square
                            size={15}
                          />
                          Finalizar
                        </button>
                      )}

                        {/* CRM_PROMOTION_DELETE_BUTTON_POSITION_V2 */}
                        {promocao.status !==
                          'ATIVA' && (

                          <button
                            type="button"
                            onClick={
                              () =>
                                excluirPromocao(
                                  promocao
                                )
                            }
                            className="flex items-center gap-2 bg-red-600 hover:bg-red-700 text-white px-3 py-2 rounded-lg text-sm"
                            title="Excluir promoção permanentemente"
                          >
                            <Trash2
                              size={16}
                            />
                            Excluir
                          </button>
                        )}

                    </div>
                  </div>
                </div>
              )
            )}
          </div>
        )}
      </div>
    </div>
  );
}
